import * as React from 'react'

import { compose, pure } from 'recompose'
import Confetti from '../../atoms/Confetti/Confetti'
import RankingTitle from '../../molecules/RankingTitle/RankingTitle'
import * as styles from './RankingResult.css'

interface RankingResultProps {
  rank: string
  name: string
}

const RankingResult: React.FunctionComponent<RankingResultProps> = ({ name, rank }) => {
  return (
    <div className={styles.container}>
      <div className={styles.namePart}>
        <RankingTitle rank={rank} />
        <h2 className={styles.name}>{name}</h2>
      </div>
      {rank === '1' ? (
        <div className={styles.confetti}>
          <Confetti />
        </div>
      ) : null}
    </div>
  )
}

export default compose<RankingResultProps, RankingResultProps>(pure)(RankingResult)
